import { Spin, Typography } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'

const LoadingScreen = () => {
    const { show, title } = useSelector(ctx => ctx.loader)
    if (show)
        return (
            <div
                style={{
                    zIndex: 9999
                }}
                className='fixed left-0 top-0 bg-[rgba(255,255,255,0.6)] flex justify-center items-center h-screen w-full ' >
                <div className="flex flex-col gap-5 items-center">
                    <Spin spinning size="large" />
                    {title && <Typography.Text>{title}</Typography.Text>}
                </div>
            </div>
        )
}

export default LoadingScreen